import { Column, Entity, PrimaryColumn } from 'typeorm'

@Entity({ name: 'TMessageSigfoxOut' })
export class TMessageSigfoxOut {
  @PrimaryColumn()
  MSG_RAW_ID: number

  @Column({ length: 8 })
  SIGFOX_ID: string

  @Column({ length: 8 })
  SIGFOX_SNUM: string // sequence number

  @Column()
  SIGFOX_TIME: number

  @Column({ length: 4 })
  SIGFOX_STAT: string

  @Column({ length: 24 })
  MSG_CONTENT: string

  @Column({ type: 'tinyint' })
  ERROR_CODE: number

  @Column({ type: 'timestamp' })
  DATE_INRECV: Date

  @Column({ type: 'timestamp' })
  DATE_CREATE: Date

  @Column({ type: 'timestamp' })
  DATE_UPDATE: Date
}
